import React from 'react';
import { Navigate, matchPath } from 'react-router-dom';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { PANEL_ROLES } from 'utils/enum';
import { getRoleRoutes, getTeamRoles } from 'utils/role-config';

const AuthRoute = ({ children }: { children: JSX.Element }) => {
  const teamRoutes = getTeamRoles();
  const role = localStorage.getItem(STORAGE_KEYS.ROLE) as PANEL_ROLES;

  if (!role) {
    localStorage.clear();
    return <Navigate to={ROUTE_KEYS.LOGIN} />;
  }

  const accessRoutes = getRoleRoutes();
  const hasAccess = accessRoutes?.find((path) => matchPath({ path }, location.pathname));
  const token: any = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const fallback = role ? teamRoutes?.[role]?.baseRoute ?? '' : '';

  if (!fallback) {
    localStorage.clear();
    return <Navigate to={ROUTE_KEYS.LOGIN} />;
  }

  return !token ? (
    <Navigate to={ROUTE_KEYS.LOGIN} />
  ) : hasAccess ? (
    children
  ) : (
    <Navigate to={fallback} />
  );
};
export default AuthRoute;
